export interface User {
  id: string; // PostgreSQL UUID
  firebaseUid?: string; // Firebase UID for authentication
  email: string;
  displayName?: string;
  workspaceId: string;
  role: UserRole;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
  /** Runtime-only flag set by WorkspaceContextInterceptor for platform admins */
  isPlatformAdmin?: boolean;
}

export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
  VIEWER = 'viewer'
}

export interface CreateUserDto {
  email: string;
  password: string;
  displayName?: string;
  workspaceId?: string;
  role?: UserRole;
}

export interface UpdateUserDto {
  displayName?: string;
  role?: UserRole;
  isActive?: boolean;
}

export interface UserStats {
  totalUsers: number;
  activeUsers: number;
  adminUsers: number;
}